export const PoolData = {
    UserPoolId: 'us-east-1_pDFSVgJs3',
    ClientId: '6mp33mfoqdf1b2g7vc7f51e6co',
};
export const PoolDataDev = {
    UserPoolId: 'us-east-1_m20whQRs5',
    ClientId: '57burfbmepn0ucsl3odm9camt',
};
//# sourceMappingURL=index.js.map